import { Text } from "../../../../components/common/typography";
import { SectionCard } from "./section-card";
import { AddressBookSection } from "../../../addresses/components/address-book-section";

/**
 * Account → Billing addresses tab.
 *
 * These are the buyer's bill-to contacts, backed by Odoo partner child
 * records with `type = invoice`.
 */
export function BillingAddressesSection() {
  return (
    <SectionCard title="Billing addresses">
      <Text variant="bodySm" tone="muted">
        Saved bill-to contacts for invoices that should go to a different
        address than your company's primary legal address.
      </Text>
      <AddressBookSection type="invoice" mode="manage" heading="" />
    </SectionCard>
  );
}
